const activeReasons = new Set<string>();

export function showCursor(reason: string): void {
  activeReasons.add(reason);
  document.body.classList.add('cursor-visible');
}

export function hideCursor(reason: string): void {
  activeReasons.delete(reason);
  if (activeReasons.size === 0) {
    document.body.classList.remove('cursor-visible');
  }
}
